import AxiosClient from "../../../services/axios.services";

class PlazasVacantesServices {
  getPlazasVacantes = (params, type) =>
    AxiosClient.get(
      type
        ? "/api/app/seleccion_contratacion_plaza_no_vacantes/"
        : "/api/app/seleccion_contratacion_plaza_vacantes/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getPlazaVacante = (id) =>
    AxiosClient.get(`/api/app/seleccion_contratacion_plaza_vacantes/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  savePlazaVacante = (data) =>
    AxiosClient.post("/api/app/seleccion_contratacion_plaza_vacantes/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editPlazaVacante = (id, data) =>
    AxiosClient.put(
      `/api/app/seleccion_contratacion_plaza_vacantes/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deletePlazaVacante = (id) =>
    AxiosClient.delete(`/api/app/seleccion_contratacion_plaza_vacantes/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new PlazasVacantesServices();
